// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".db-admin-table[data-v-15dafcb1]{table-layout:fixed;width:100%}.db-admin-table td[data-v-15dafcb1],.db-admin-table th[data-v-15dafcb1]{font-size:12px;padding:.3rem;max-width:130px;vertical-align:top}.cell-truncate[data-v-15dafcb1]{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;word-break:break-word;line-height:1.15}", ""]);
// Exports
module.exports = exports;
